import styled from "styled-components";

export const MultiSegmentProgressWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    box-sizing: border-box;
    border-radius: 5px;
    height: 10px;
    overflow: hidden;
`;

export const Segment = styled.div`

`;


